<template>
  <div>
    <template v-if="welcome_quickreplies">
      <div>
        <template v-if="isEdit">
          <div
            class="form-control"
            :class="{'has-error' : errorTag.length > 0}"
            style="margin-top: 15px;"
          >
            <tags
              v-model="tag"
              :tags="replies"
              @tags-changed="newTags => replies = newTags"
              :max="10"
              @before-adding-tag="checkTag"
              :btnText="$t('Add choice')"
            ></tags>
            <span class="text-error" v-if="errorTag.length > 0">
              <template
                v-if="errorTag.includes('overmaxlength')"
              >{{$t('Message cannot be longer than 20 alphabets')}}</template>
              <template
                v-else-if="errorTag.includes('overtagmax')"
              >{{$t('Choices cannot be more than 10 items')}}</template>
              <template v-else-if="errorTag.includes('duplicate')">{{$t('Duplicate Choice')}}</template>
            </span>
          </div>
        </template>
        <template v-else>
          <div class="quickreply">
            <ul class="tags">
              <li class="tag" v-for="(reply,index) in replies" :key="'reply_'+index">{{reply.text}}</li>
            </ul>
          </div>
        </template>
      </div>
      <div class="text-xs-center" style="margin-top: 25px;margin-bottom: 25px;">
        <template v-if="isEdit">
          <slot name="footer" :cancelEdit="cancelEdit" :saveContent="saveContent">
            <v-btn color="grey" outline @click="cancelEdit">{{$t('cancel')}}</v-btn>
            <v-btn color="primary" depressed @click="saveContent">{{$t('Save')}}</v-btn>
          </slot>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import config from '@/config'
import api from '@/api'

import VueTagsInput from '@johmun/vue-tags-input'
import FacebookScreen from '@/components/elements/FacebookScreen'
import Tags from '@/components/elements/Tags'

export default {
  props: ['value', 'isEdit'],
  data: function() {
    return {
      welcome_quickreplies: undefined,
      tag: '',

      errorTag: []
    }
  },
  components: {
    FacebookScreen,
    VueTagsInput,
    Tags
  },
  created: function() {
    this.welcome_quickreplies = Object.assign({}, this.value)

    this.cached_welcome_quickreplies = Object.assign({}, this.value)
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    replies: {
      get() {
        var vm = this
        if (
          vm.welcome_quickreplies &&
          vm.welcome_quickreplies.contentvalue &&
          vm.welcome_quickreplies.contentvalue != null &&
          vm.welcome_quickreplies.contentvalue != ''
        ) {
          var tags = vm.welcome_quickreplies.contentvalue.split(',')
          var result = []
          $.each(tags, function(index, val) {
            result.push({ text: val })
          })
          this.$emit('onChangeChoice', result)
          return result
        } else {
          this.$emit('onChangeChoice', [])
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.welcome_quickreplies.contentvalue = result.join(',')

        // vm.$emit('input',Object.assign({}, this.welcome_quickreplies))
      }
    }
  },
  methods: {
    checkTag: function(obj) {
      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
      // else
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (this.replies.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        //this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    cancelEdit: function() {
      var vm = this
      this.welcome_quickreplies = Object.assign({}, this.cached_welcome_quickreplies)

      vm.$emit('input', Object.assign({}, this.welcome_quickreplies))
      vm.$emit('onSave')
    },
    saveContent: function() {
      var vm = this
      vm.sendRequest(this.welcome_quickreplies)
      this.cached_welcome_quickreplies = Object.assign({}, this.welcome_quickreplies)

      vm.$emit('input', Object.assign({}, this.cached_welcome_quickreplies))
      vm.$emit('onSave')
    },
    sendRequest: function(content, callback) {
      var vm = this
      api.updateConfig(content, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    }
  },
  watch: {
    value: function() {
      this.welcome_quickreplies = Object.assign({}, this.value)

      this.cached_welcome_quickreplies = Object.assign({}, this.value)
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/chatbot/QuickReply.vue